import PageHero from "../components/PageHero";
import Founder from "../components/sections/Founder";
import WhyChooseUs from "../components/sections/WhyChooseUs";
import SiteVisitCTA from "../components/sections/SiteVisitCTA";

export default function AboutPage() {
  return (
    <div data-testid="about-page">
      <PageHero
        eyebrow="About Us"
        title="Building trust. Creating legacies."
        subtitle="A decade of advising serious investors across India, helping them discover and acquire generational real estate assets in Dholera Smart City."
        image="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2070&auto=format&fit=crop"
      />
      <Founder />
      <WhyChooseUs />
      <SiteVisitCTA />
    </div>
  );
}
